import React, { useLayoutEffect, useState } from 'react';
import ScheduleBasicInfo from './components/ScheduleBasicInfo.js.jsx';
import ScheduleFrequency from './components/ScheduleFrequency.js.jsx';
import ScheduleAdvanceSettings from './components/ScheduleAdvanceSettings.js.jsx';
import ScheduleDueDateSettings from './components/ScheduleDueDateSettings.js.jsx';
import LineItems from './components/LineItems.js.jsx';
import classNames from 'classnames';
import newLeaseModalStyles from '../../stylesheets/management_site/newLeaseModal.module.scss';

const ScheduleForm = ({
  initialData = {},
  incomeOptions = [],
  fieldPrefix = 'lease[schedules_attributes][0]',
  parsedScheduleData = null,
}) => {
  const chargeDateTypeMap = {
    offset: 'relative',
    fixedDay: 'fixed',
  };

  const dueDateTypeMap = {
    offset: 'relative',
    fixedDay: 'fixed',
    endOfMonth: 'end of month',
  };

  const parsedChargeDateType = parsedScheduleData?.chargeDate?.type;
  const parsedDueDateType = parsedScheduleData?.dueDate?.type;
  const [formData] = useState({
    name: parsedScheduleData?.name || initialData.name || '',
    startDate: parsedScheduleData?.startDate || initialData.startDate || '',
    endDate: parsedScheduleData?.endDate || initialData.endDate || '',
    monthToMonth: parsedScheduleData?.monthToMonth ?? initialData.monthToMonth,
  });
  const [scheduleType, setScheduleType] = useState(
    parsedScheduleData?.scheduleFrequency ||
      initialData.scheduleType ||
      'monthly'
  );
  const [monthlyDayEnd, setMonthlyDayEnd] = useState(
    initialData.monthlyDayEnd || 'specify'
  );
  const [daysAdvanceType, setDaysAdvanceType] = useState(
    chargeDateTypeMap[parsedChargeDateType] ||
      initialData.daysAdvanceGenerateChargeType ||
      'relative'
  );
  const [dueDateType, setDueDateType] = useState(
    dueDateTypeMap[parsedDueDateType] || initialData.dueDateType || 'relative'
  );
  const [items, setItems] = useState([0]);
  const defaultItemId = initialData.itemId;
  const defaultAmount =
    parsedScheduleData?.amount || initialData.amount || '0.00';

  const addItem = () => setItems((prev) => [...prev, prev.length]);

  const removeItem = (index) =>
    setItems((prev) => prev.filter((_, i) => i !== index));

  const flattenIncomeOptions = (opts) => {
    if (!opts?.length) return [];
    const looksGrouped = opts[0]?.options && Array.isArray(opts[0].options);
    if (!looksGrouped) return opts;
    return opts.flatMap((g) =>
      g.options.map((o) => ({ value: o.value, label: o.label }))
    );
  };

  const incomeSelectOptions = flattenIncomeOptions(incomeOptions);

  useLayoutEffect(() => {
    if (window.mdc && typeof window.mdc.autoInit === 'function') {
      const container = document.getElementById('schedule-detail-form');
      window.mdc.autoInit(container);
    }
    if (typeof window.initSelect2 === 'function') {
      window.initSelect2('#schedule-detail-form');
    }
    if (typeof window.initDatepicker === 'function') {
      window.initDatepicker('#schedule-detail-form');
    }
    if (typeof window.initReactDatepicker === 'function') {
      window.initReactDatepicker(
        '#schedule-detail-form .pm-datepicker-field',
        null
      );
    }
    if (typeof window.initDatepicker === 'function') {
      window.initDatepicker('#schedule-detail-form');
    }
    if (typeof window.attachFormatMoneyListener === 'function') {
      window.attachFormatMoneyListener();
    }
  }, [incomeOptions, scheduleType, items]);

  return (
    <div id="schedule-detail-form" className={newLeaseModalStyles.body}>
      <ScheduleBasicInfo
        formData={formData}
        fieldPrefix={fieldPrefix}
        scheduleType={scheduleType}
      />

      <input
        type="hidden"
        name={`${fieldPrefix}[due_date_type]`}
        value="relative"
      />

      <div
        className={classNames(
          'pm-flex',
          'pm-flex-3',
          newLeaseModalStyles.scheduleFlexContainer
        )}
      >
        <ScheduleFrequency
          scheduleType={scheduleType}
          setScheduleType={setScheduleType}
          fieldPrefix={fieldPrefix}
          monthlyDayEnd={monthlyDayEnd}
          setMonthlyDayEnd={setMonthlyDayEnd}
          parsedScheduleOptions={
            parsedScheduleData
              ? {
                  monthlyOptions: parsedScheduleData.monthlyOptions,
                  weeklyOptions: parsedScheduleData.weeklyOptions,
                  dailyOptions: parsedScheduleData.dailyOptions,
                  onceOptions: parsedScheduleData.onceOptions,
                }
              : null
          }
        />

        <ScheduleAdvanceSettings
          fieldPrefix={fieldPrefix}
          initialData={initialData}
          daysAdvanceType={daysAdvanceType}
          setDaysAdvanceType={setDaysAdvanceType}
          parsedChargeDate={parsedScheduleData?.chargeDate}
        />
        <ScheduleDueDateSettings
          fieldPrefix={fieldPrefix}
          initialData={initialData}
          dueDateType={dueDateType}
          setDueDateType={setDueDateType}
          parsedDueDate={parsedScheduleData?.dueDate}
        />
      </div>

      <div
        className={newLeaseModalStyles.newLeaseModalSection}
        id="schedule-template-transaction-container"
      >
        <input type="hidden" name={`${fieldPrefix}[entity_id]`} />
        <input
          type="hidden"
          name={`${fieldPrefix}[template_transaction_attributes][type]`}
          value="P2Invoice"
        />

        <LineItems
          wrapperId="charge-fields"
          itemType="transaction-line-item"
          newButtonId="new_transaction_schedule_template_item"
          items={items}
          onAdd={addItem}
          onRemove={removeItem}
          defaultAmount={defaultAmount}
          selectLabel="Income Item"
          selectOptions={incomeSelectOptions}
          selectDefaultValue={(idx) => (idx === 0 ? defaultItemId || '' : '')}
          namePattern={`${fieldPrefix}[template_transaction_attributes][items_attributes][{{index}}][{{field}}]`}
        />
      </div>
    </div>
  );
};

export default ScheduleForm;
